import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'app-careers-page',
    templateUrl: './careers-page.component.html',
    styleUrls: ['./careers-page.component.scss']
})
export class CareersPageComponent implements OnInit {

    constructor(private meta: Meta, private titleService: Title) { }

    ngOnInit(): void {
        this.titleService.setTitle('Careers at Union Fire Protection Qatar');
        this.meta.updateTag({
            name: 'description',
            content: 'Join our team at Union Fire Protection. Explore career opportunities in fire safety, engineering, and technical services in Qatar.'
        });
    }

    pageTitle = [
        {
            bgImage: 'assets/img/careers-banner.jpg',
            title: 'Join Our Team'
        }
    ]

    careersContent = [
        {
            subTitle: "CAREERS",
            title: "Build Your Career with Us",
            paragraph: "Union Fire Protection is always looking for talented and dedicated professionals to join our growing team. We offer competitive compensation, professional development opportunities, and a dynamic work environment in Qatar's leading fire protection company."
        }
    ]

    openPositions = [
        {
            title: 'Fire Safety Engineer',
            department: 'Engineering',
            location: 'Doha, Qatar',
            type: 'Full-time',
            experience: '3-5 years',
            description: 'Design and implement fire protection systems for commercial and residential projects.',
            requirements: [
                'Bachelor\'s degree in Mechanical/Electrical Engineering',
                'Experience with fire alarm and sprinkler systems',
                'Knowledge of Qatar Civil Defense regulations',
                'AutoCAD proficiency'
            ]
        },
        {
            title: 'Fire Alarm Technician',
            department: 'Technical',
            location: 'Doha, Qatar',
            type: 'Full-time',
            experience: '2-4 years',
            description: 'Install, maintain, and troubleshoot fire alarm systems across various projects.',
            requirements: [
                'Technical diploma in Electronics/Electrical',
                'Experience with fire alarm panel programming',
                'Valid Qatar driving license',
                'Good communication skills'
            ]
        },
        {
            title: 'Project Manager',
            department: 'Management',
            location: 'Doha, Qatar',
            type: 'Full-time',
            experience: '5+ years',
            description: 'Oversee fire protection projects from planning to completion, ensuring quality and timely delivery.',
            requirements: [
                'Bachelor\'s degree in Engineering or related field',
                'PMP certification preferred',
                'Experience in fire protection industry',
                'Strong leadership and communication skills'
            ]
        },
        {
            title: 'Sales Executive',
            department: 'Sales',
            location: 'Doha, Qatar',
            type: 'Full-time',
            experience: '2-3 years',
            description: 'Develop new business opportunities and maintain client relationships in the fire protection sector.',
            requirements: [
                'Bachelor\'s degree in Business or related field',
                'Sales experience in construction/MEP industry',
                'Excellent communication and negotiation skills',
                'Valid Qatar driving license'
            ]
        }
    ]

    benefits = [
        {
            icon: 'bx-dollar-circle',
            title: 'Competitive Salary',
            description: 'Market-leading compensation packages'
        },
        {
            icon: 'bx-health',
            title: 'Health Insurance',
            description: 'Comprehensive medical coverage'
        },
        {
            icon: 'bx-briefcase',
            title: 'Career Growth',
            description: 'Professional development opportunities'
        },
        {
            icon: 'bx-time',
            title: 'Work-Life Balance',
            description: 'Flexible working arrangements'
        }
    ]

}
